module.exports = __webpack_public_path__ + "static/assets/df72b2f945374627f9efca3f20e4e8aa.ttf";